import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Mic,
  Users,
  Send,
  Inbox,
  BarChart3,
  Settings,
  ChevronLeft,
  AlertTriangle,
} from 'lucide-react';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/voice-profile', icon: Mic, label: 'Voice Profile' },
  { to: '/prospects', icon: Users, label: 'Prospects' },
  { to: '/campaigns', icon: Send, label: 'Campaigns' },
  { to: '/inboxes', icon: Inbox, label: 'Inboxes' },
  { to: '/analytics', icon: BarChart3, label: 'Analytics' },
];

export default function Sidebar({ collapsed, onToggle, onReportIssue, inboxCount = 0 }) {
  return (
    <>
      {/* Mobile overlay */}
      {!collapsed && (
        <div
          className="fixed inset-0 bg-black/20 z-30 lg:hidden"
          onClick={onToggle}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full z-40 flex flex-col transition-all duration-200
          ${collapsed ? '-translate-x-full lg:translate-x-0 lg:w-16' : 'w-64'}`}
        style={{ backgroundColor: '#0f172a', color: '#e2e8f0' }}
      >
        {/* Logo */}
        <div className="h-16 flex items-center gap-3 px-4 border-b border-white/10">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <span className="text-white font-bold text-sm">A</span>
          </div>
          {!collapsed && (
            <span className="text-lg font-bold text-white">AgentDash</span>
          )}
        </div>

        {/* Nav */}
        <nav className="flex-1 py-4 px-2 space-y-1 overflow-y-auto">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
                ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-slate-300/70 hover:bg-white/10 hover:text-white'
                }
                ${collapsed ? 'justify-center' : ''}`
              }
              onClick={() => {
                if (window.innerWidth < 1024) onToggle();
              }}
            >
              <span className="relative">
                <Icon className="w-5 h-5 flex-shrink-0" />
                {label === 'Inboxes' && inboxCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                    {inboxCount > 9 ? '9+' : inboxCount}
                  </span>
                )}
              </span>
              {!collapsed && <span>{label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* Bottom settings + collapse */}
        <div className="p-2 border-t border-white/10 space-y-1">
          <NavLink
            to="/settings"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-300/70 hover:bg-white/10 hover:text-white transition-colors"
          >
            <Settings className="w-5 h-5 flex-shrink-0" />
            {!collapsed && <span>Settings</span>}
          </NavLink>
          <button
            onClick={onReportIssue}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-300/70 hover:bg-white/10 hover:text-white transition-colors w-full ${collapsed ? 'justify-center' : ''}`}
          >
            <AlertTriangle className="w-5 h-5 flex-shrink-0" />
            {!collapsed && <span>Report Issue</span>}
          </button>
          <button
            onClick={onToggle}
            className="hidden lg:flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:bg-white/10 hover:text-white w-full transition-colors"
          >
            <ChevronLeft
              className={`w-5 h-5 transition-transform ${collapsed ? 'rotate-180' : ''}`}
            />
            {!collapsed && <span>Collapse</span>}
          </button>
        </div>
      </aside>
    </>
  );
}
